<ul ngbNav #clientInformationsTabset="ngbNav" (navChange)="onTabChange($event)">
    <li [ngbNavItem]="'client-info-tab'">
        <a ngbNavLink>Client</a>
        <ng-template ngbNavContent>
            <app-client-tab
                [client]="client"
                [company]="company"
                [createNewClientEnv]="createNewClientEnv"
                [selectedCompanyAction]="selectedCompanyAction"
                (enableCompanySection)="getEnableCompanySectionValue($event)"
                (getSelectedCompany)="getSelectedCompany($event)"></app-client-tab>
        </ng-template>
    </li>
    <li [ngbNavItem]="'company-info-tab'" [disabled]="hideCompanyTab">
        <a ngbNavLink>Company</a>
        <ng-template ngbNavContent>
            <app-company-tab
                [client]="client"
                [company]="company"
                [countrySelectOptions]="countrySelectOptions"
                [createNewClientEnv]="createNewClientEnv"
                [countryObjects]="countryObjects"></app-company-tab>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="clientInformationsTabset"></div>
